// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ib-0";
export var actionModalContentContainer = "_ib-1";
export var createTagButton = "_ib-2";
export var footerContainer = "_ib-7";
export var fullWidthDivider = "_ib-3";
export var hasCreateTagButton = "_ib-4";
export var noCreateTagButton = "_ib-5";
export var tagsContainer = "_ib-6";
export var tagsModalContentContainer = "_ib-8";